module.exports = __webpack_public_path__ + "e0ac2e4a9aaec9e5ea2c4f4933dd77f4.svg";